import { Card, CardContent } from "@/components/ui/card";
import { EditBase, Form, useEditContext, type MutationMode } from "ra-core";

import type { Prospect } from "../types";
import { FormToolbar } from "../layout/FormToolbar";
import { ProspectAside } from "./ProspectAside";
import { ProspectInputs } from "./ProspectInputs";
import {
  cleanupProspectForEdit,
  defaultEmails,
  defaultPhones,
} from "./prospectModel";

export const ProspectEdit = ({
  mutationMode,
}: {
  mutationMode?: MutationMode;
}) => (
  <EditBase
    redirect="show"
    transform={cleanupProspectForEdit}
    mutationMode={mutationMode}
  >
    <ProspectEditContent />
  </EditBase>
);

const normalizeArrayFields = (record: Prospect) => ({
  ...record,
  phones: record.phones && record.phones.length > 0 ? record.phones : defaultPhones,
  emails: record.emails && record.emails.length > 0 ? record.emails : defaultEmails,
});

const ProspectEditContent = () => {
  const { isPending, record } = useEditContext<Prospect>();
  if (isPending || !record) return null;
  return (
    <div className="mt-2 flex gap-8">
      <Form
        className="flex flex-1 flex-col gap-4"
        record={normalizeArrayFields(record)}
      >
        <Card>
          <CardContent>
            <ProspectInputs />
            <FormToolbar />
          </CardContent>
        </Card>
      </Form>
      <ProspectAside link="show" />
    </div>
  );
};
